(function () {
  'use strict';

  function init(root) {
    root.querySelectorAll('.nexaro-steps').forEach(function (section) {
      initSection(section);
    });
  }

  function initSection(section) {
    var items = Array.from(section.querySelectorAll('.nexaro-steps__item'));

    items.forEach(function (item) {
      var toggle = item.querySelector('.nexaro-steps__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        if (item.classList.contains('is-active')) return;
        activateItem(section, items, item);
      });
    });
  }

  function activateItem(section, items, targetItem) {
    var targetIndex = parseInt(targetItem.dataset.blockIndex, 10);

    items.forEach(function (item) {
      var collapse = item.querySelector('.nexaro-steps__collapse');
      var toggle = item.querySelector('.nexaro-steps__toggle');
      var isTarget = item === targetItem;

      item.classList.toggle('is-active', isTarget);
      if (collapse) collapse.classList.toggle('is-open', isTarget);
      if (toggle) toggle.setAttribute('aria-expanded', String(isTarget));
    });

    section.querySelectorAll('.nexaro-steps__panel-image').forEach(function (panel, i) {
      panel.classList.toggle('is-active', i === targetIndex);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
